import { Skeleton } from '@mui/material'
import { Modal, Row, Tabs } from 'components/core-v2'
import { noop } from 'lodash'

interface Props {
  onClose: () => void
}
export const Loading = ({ onClose }: Props) => (
  <>
    <Modal.Header id="assets-modal-label" onClose={onClose}>
      <Skeleton height="20px" variant="rectangular" width="160px" />
    </Modal.Header>
    <Modal.Body>
      <Tabs.List ruleClassName="mb-4" spacing="md">
        <Tabs.Tab isSelected value="details" onClick={noop}>
          Details
        </Tabs.Tab>
        <Tabs.Tab isSelected={false} value="strategies" onClick={noop}>
          Strategy permissions
        </Tabs.Tab>
      </Tabs.List>
      {new Array(12).fill(null).map((x, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Row key={`asset-information-modal-skeleton-${index}`} showTopBorder={index !== 0}>
          <Skeleton height="15px" variant="rectangular" width="160px" />
          <Skeleton height="15px" variant="rectangular" width="160px" />
        </Row>
      ))}
    </Modal.Body>
  </>
)
